export interface GroupMembershipCounts {
  addedCount: number;
  alreadyMemberCount: number;
}

/** Read the membership counts from a successful add-to-group response. */
export function readGroupMembershipCounts(body: unknown): GroupMembershipCounts {
  if (typeof body !== 'object' || body === null) {
    throw new Error('The server did not say how many records were added.');
  }
  const record = body as Record<string, unknown>;
  return {
    addedCount: requireCount(record.added_count),
    alreadyMemberCount: requireCount(record.already_member_count),
  };
}

/** What to tell the user after a batch of records is sent to a group. */
export function addedToGroupMessage(counts: GroupMembershipCounts): string {
  const { addedCount, alreadyMemberCount } = counts;
  if (addedCount === 0) {
    return alreadyMemberCount === 1
      ? 'Already in this group'
      : `All ${alreadyMemberCount} records are already in this group`;
  }
  if (alreadyMemberCount === 0) {
    return addedCount === 1 ? 'Record added to group' : `Added ${addedCount} records to the group`;
  }
  const already =
    alreadyMemberCount === 1 ? '1 was already in this group' : `${alreadyMemberCount} were already in this group`;
  return `Added ${addedCount}. ${already}.`;
}

function requireCount(value: unknown): number {
  if (typeof value !== 'number' || !Number.isInteger(value) || value < 0) {
    throw new Error('The server did not say how many records were added.');
  }
  return value;
}
